module.exports = __webpack_public_path__ + "static/media/NTR-msft.a15c5bbc.png";